export default __webpack_public_path__ + "static/media/asscher.c1c9996a.svg";